import * as colors from "../../../constants/colors";
import {useState} from "react";

const RadioBoxEmpty = ({onChange, isInactive, checked}) => {

    const [hover, setHover] = useState(false);
    const defaultStyle = {
        backgroundColor: colors.color_white,
        border: "none",
        boxShadow: "1px 0 4px rgba(178, 178, 178, 0.29)",
        borderRadius: "5px",
        width: 25,
        height: 25,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        margin: 4,
        cursor: isInactive ? "default" : "pointer",
    }

    function handleClick(e){
        onChange(e)
    }

    return(
        <div
            style={defaultStyle}
            onClick={!isInactive? handleClick : null}
            
            onMouseEnter={!isInactive? ()=>setHover(true) : null}
            onMouseLeave={!isInactive? ()=>setHover(false) : null}
        >
            {isInactive === true &&
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.5 3.75L5.625 10.625L2.5 7.5" stroke="#B1B1B1" stroke-Linecap="round"
                          stroke-Linejoin="round"/>
                </svg>
            }
            {hover === true && checked === false &&
                <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 0.75L3.625 7.625L0.5 4.5" stroke="#F4BEBE" stroke-Linecap="round"
                          stroke-Linejoin="round"/>
                </svg>
            }
            {checked===true &&
                <svg width="11" height="9" viewBox="0 0 11 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.5 0.75L3.625 7.625L0.5 4.5" stroke="#E12F2F" strokeLinecap="round"
                          strokeLinejoin="round"/>
                </svg>
            }
        </div>
    )
}

export default RadioBoxEmpty